// extracted by mini-css-extract-plugin
export default {"research":"index_research_8MK7D clearfix","vote":"index_vote_eP0xx","voteEnd":"index_voteEnd_bj9R-"};